/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBaselineDensitySmall = createReactComponent("outline", "baseline-density-small", "IconBaselineDensitySmall", [["path", { "d": "M4 3h16", "key": "svg-0" }], ["path", { "d": "M4 9h16", "key": "svg-1" }], ["path", { "d": "M4 15h16", "key": "svg-2" }], ["path", { "d": "M4 21h16", "key": "svg-3" }]]);

export { IconBaselineDensitySmall as default };
//# sourceMappingURL=IconBaselineDensitySmall.mjs.map
